import { AxiosError } from 'axios';

/** The code the server refuses a booking over a quota with. */
export const QUOTA_EXCEEDED = 'QUOTA_EXCEEDED';

/**
 * Why the server refused a booking ("[{ error }]"), a quota overrun said in our words
 * (`quotaExceeded`, its code alone would be shown otherwise); none when the server says nothing.
 */
export const getBookingErrorMessage = (error: unknown, quotaExceeded: string): string | undefined => {
  const response = (error as AxiosError | undefined)?.response;
  const body = response?.data as { error?: string }[] | undefined;
  const message = Array.isArray(body) ? body[0]?.error : undefined;

  if (response?.status === 400 && message === QUOTA_EXCEEDED) {
    return quotaExceeded;
  }

  return message || undefined;
};
